import { render } from "./FinishChanges.vue?vue&type=template&id=5a22a211&scoped=true"
import script from "./FinishChanges.vue?vue&type=script&lang=js"
export * from "./FinishChanges.vue?vue&type=script&lang=js"

import "./FinishChanges.vue?vue&type=style&index=0&id=5a22a211&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a22a211"]])

export default __exports__